import { Routes } from '@angular/router';
import { AuthGuard } from '@core/guards/auth/auth.guard';
import { LoginGuard } from '@core/guards/login/login.guard';
import { LoginLayoutComponent } from '@core/layout/login-layout/login-layout.component';
import { MainLayoutComponent } from '@core/layout/main-layout/main-layout.component';
import { AuthComponent } from '@feature/auth/auth.component';
import { OtpVerifyComponent } from '@feature/auth/verify/otp-verify/otp-verify.component';
import { NotFoundComponent } from '@feature/dashboard/not-found/not-found.component';
import { otpGuard } from '@core/guards/otp/otp.guard';
import { clientNameGuard } from '@core/guards/client-name/client-name.guard';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'auth/login',
  },
  {
    path: 'auth',
    component: LoginLayoutComponent,
    children: [
      { path: 'login', component: AuthComponent, canActivate: [LoginGuard] },

      {
        path: 'otp_verify',
        component: OtpVerifyComponent,
        canActivate: [otpGuard],
      },
    ],
  },
  {
    path: ':clientName',
    redirectTo: ':clientName/dashboard/publication',
    pathMatch: 'full',
  },

  {
    path: ':clientName/dashboard',
    component: MainLayoutComponent,
    canActivate: [AuthGuard],
    canActivateChild: [clientNameGuard],
    children: [
      {
        path: 'publication',
        loadComponent: () =>
          import('../app/feature/dashboard/thesis/thesis.component').then(
            m => m.ThesisComponent
          ),
      },
      {
        path: 'documents/list',
        loadComponent: () =>
          import('../app/feature/dashboard/documents/documents.component').then(
            m => m.DocumentsComponent
          ),
      },
      {
        path: 'profile',
        loadComponent: () =>
          import('../app/dummy-pages/user-info/profile/profile.component').then(
            m => m.ProfileComponent
          ),
      },
      {
        path: 'user-management/user/list',
        loadComponent: () =>
          import(
            '../app/feature/dashboard/user-management/users/components/user-list/user-list.component'
          ).then(m => m.UserListComponent),
      },
      {
        path: 'user-management/user/add',
        loadComponent: () =>
          import(
            '../app/feature/dashboard/user-management/users/components/upsert-user/upsert-user.component'
          ).then(m => m.UpsertUserComponent),
      },
      {
        path: 'user-management/user/edit/:id',
        loadComponent: () =>
          import(
            '../app/feature/dashboard/user-management/users/components/upsert-user/upsert-user.component'
          ).then(m => m.UpsertUserComponent),
      },
      {
        path: 'user-management/role/list',
        loadComponent: () =>
          import(
            '../app/feature/dashboard/user-management/roles/components/role-list/role-list.component'
          ).then(m => m.RoleListComponent),
      },
      {
        path: 'user-management/role/add',
        loadComponent: () =>
          import(
            '../app/feature/dashboard/user-management/roles/components/upsert-role/upsert-role.component'
          ).then(m => m.UpsertRoleComponent),
      },
      {
        path: 'user-management/role/edit/:id',
        loadComponent: () =>
          import(
            '../app/feature/dashboard/user-management/roles/components/upsert-role/upsert-role.component'
          ).then(m => m.UpsertRoleComponent),
      },
      {
        path: 'user-management/group/list',
        loadComponent: () =>
          import(
            '../app/feature/dashboard/user-management/permissions/components/permission-list/permission-list.component'
          ).then(m => m.PermissionListComponent),
      },
      {
        path: 'user-management/group/add',
        loadComponent: () =>
          import(
            '../app/feature/dashboard/user-management/permissions/components/upsert-permission/upsert-permission.component'
          ).then(m => m.UpsertPermissionComponent),
      },
      {
        path: 'user-management/group/edit/:id',
        loadComponent: () =>
          import(
            '../app/feature/dashboard/user-management/permissions/components/upsert-permission/upsert-permission.component'
          ).then(m => m.UpsertPermissionComponent),
      },
      {
        path: 'user-management/client/list',
        loadComponent: () =>
          import(
            '../app/feature/dashboard/user-management/clients/components/client-list/client-list.component'
          ).then(m => m.ClientListComponent),
      },
      {
        path: 'user-management/client/add',
        loadComponent: () =>
          import(
            '../app/feature/dashboard/user-management/clients/components/upsert-client/upsert-client.component'
          ).then(m => m.UpsertClientComponent),
      },
      {
        path: 'user-management/client/edit/:id',
        loadComponent: () =>
          import(
            '../app/feature/dashboard/user-management/clients/components/upsert-client/upsert-client.component'
          ).then(m => m.UpsertClientComponent),
      },
      {
        path: 'user-management/admins/list',
        loadComponent: () =>
          import(
            '../app/feature/dashboard/user-management/admins/components/admin-list/admin-list.component'
          ).then(m => m.AdminListComponent),
      },
      {
        path: 'user-management/admins/add',
        loadComponent: () =>
          import(
            '../app/feature/dashboard/user-management/admins/components/upsert-admin/upsert-admin.component'
          ).then(m => m.UpsertAdminComponent),
      },
      {
        path: 'user-management/admins/edit/:id',
        loadComponent: () =>
          import(
            '../app/feature/dashboard/user-management/admins/components/upsert-admin/upsert-admin.component'
          ).then(m => m.UpsertAdminComponent),
      },
      {
        path: '',
        redirectTo: '/dashboard/publication',
        pathMatch: 'full',
      },
    ],
  },

  { path: '**', component: NotFoundComponent },
];
